@if (notificationIcons$ | async; as messageList) {
  @if (messageList.length !== 0) {
    @for (message of messageList; track message; let last = $last) {
      <div
        class="notifications"
        [elementIsIntoView]="last"
        (scrolledIntoView)="onScrolledToBottom(messageList.length)"
        (click)="onClickNotification(message)"
        [ngClass]="{ pointer: message.event.target_path }">
        <bp-icon
          class="icon"
          [icon]="message.icon_name"
          size="24"
          theme="regular"
				[ngClass]="{
					error: message.state === notificationState.error,
					success: message.state === notificationState.success,
					warning: message.state === notificationState.warning,
					info: message.state === notificationState.info,
					neutral: message.state === notificationState.neutral
				}">
        </bp-icon>
        <div class="description">
          <div class="description-title">{{ message.event.title }}</div>
          <div class="description-content">{{ message.event.subtitle }}</div>
          <div class="description-time">{{ message.created_at | date_from_now | translate }}</div>
        </div>
        @if (!message.is_seen) {
          <div id="unread-notification"></div>
        }
      </div>
    }
  } @else {
    <empty-notification-board></empty-notification-board>
  }
  @if (isLoading$ | async) {
    <loading-spinner></loading-spinner>
  }
  @if ((endOfNotificationList$ | async) && messageList.length > notificationPerPage) {
    <div class="notifications-success">{{ "notification_center_all_messages_loaded" | translate }}</div>
  }
}
